import { render } from "./TravelView.vue?vue&type=template&id=891b5346&scoped=true"
import script from "./TravelView.vue?vue&type=script&lang=js"
export * from "./TravelView.vue?vue&type=script&lang=js"

import "./TravelView.vue?vue&type=style&index=0&id=891b5346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891b5346"]])

export default __exports__